import { render, staticRenderFns } from "./MyriadTimeStudy.vue?vue&type=template&id=2c22601a&scoped=true&"
import script from "./MyriadTimeStudy.vue?vue&type=script&lang=js&"
export * from "./MyriadTimeStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22601a",
  null
  
)

export default component.exports